const INV_API_URL = "https://rws.rodelag.com/";
const INV_API_TOKEN = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHAiOiJTaG9waWZ5IiwidXN1YXJpbyI6InJvZGVsYWcifQ.DJnKY125_qWfyrnjCE35yfGtIJBGZW_GO68EUK3VaCA";
const INV_EXCLUDE = /Bodega|CEDI|DOCUMENTOS|Herminia|Mega Mall|Outlet/i;

function buildInvQuery(sku){
  return JSON.stringify({
    query: `query { middleware_productos(cursor:0, limite:50, busqueda:{ itemNumber:{ eq:"${sku}" } }) { productos { inventario { wareHouse cantidad } } } }`
  });
}

async function fetchInventario(sku){
  const response = await fetch(INV_API_URL,{
    method:"POST",
    headers:{"Content-Type":"application/json","Authorization":INV_API_TOKEN},
    body:buildInvQuery(sku)
  });
  if(!response.ok) throw new Error("API error "+response.status);
  const json = await response.json();
  const productos = json && json.data && json.data.middleware_productos && json.data.middleware_productos.productos;
  if(!productos || !productos.length) return null;
  return productos[0].inventario || [];
}

function estadoDe(c){
  if(c > 5) return {label:"Disponible", cls:"disponible"};
  if(c >= 1) return {label:"Bajo", cls:"bajo"};
  return {label:"Agotado", cls:"agotado"};
}

class ProductInventario extends HTMLElement{
  connectedCallback(){
    this.listEl = this.querySelector("[data-inventario-list]");
    this.sku = this.dataset.sku;
    this.load(this.sku);
    if(typeof subscribe === "function"){
      subscribe("variant:change", (data)=>{
        const ns = data && data.variant && data.variant.sku;
        if(ns && ns !== this.sku){ this.sku = ns; this.load(ns); }
      });
    }
  }
  async load(sku){
    if(!sku){ this.hidden = true; return; }
    this.classList.add("loading");
    try{
      const inv = await fetchInventario(sku);
      if(!inv || !inv.length){ this.hidden = true; return; }
      const vis = inv.filter(it => it.wareHouse && !INV_EXCLUDE.test(it.wareHouse));
      if(!vis.length){ this.hidden = true; return; }
      this.render(vis);
      this.classList.remove("loading");
      this.hidden = false;
    }catch(e){ this.hidden = true; }
  }
  render(items){
    items.sort((a,b)=> a.wareHouse.localeCompare(b.wareHouse, "es"));
    this.listEl.innerHTML = items.map(it=>{
      const e = estadoDe(it.cantidad);
      return '<div class="inventario-sucursal"><span class="inventario-nombre">'+it.wareHouse+':</span> <span class="inventario-estado inventario-'+e.cls+'">'+e.label+'</span></div>';
    }).join("");
  }
}
customElements.define("product-inventario", ProductInventario);
